import has from 'lodash.has';

/**
 * Return a synchronous validate function to be used by reduxForm decorator
 * @param {array of objects} fields
 * {
 * 		name: name of the field
 *   	description: (optional) for example, if the name is fullname, this might be Full name which
 *  		will be replaced with 'Full name is required.'
 * }
 */
export const validateRequiredFields = fields =>
	function validate(values) {
		const errors = {};
		const requiredFields = fields;
		requiredFields.forEach(field => {
			if (!values[field.name]) {
				errors[field.name] = has(field, 'description')
					? `${field.description} is required`
					: 'Required';
			}
		});

		return errors;
	};

